import PreviewExpandable from 'app/features/questionnaires/components/PreviewExpandable';
import { useSelector } from 'react-redux';
import { selectQuestionnaireRoutes } from '../../routes/slice';

import PreviewBusinessType from './BusinessType/preview';
import PreviewGeneralInfo from './GeneralInfo/preview';
import PreviewOwners from './Owners/preview';
import PreviewIndustryandprimaryactivity from './Industryandprimaryactivity/preview';

export interface IPreviewBusinessInfoProps {}

export default function PreviewBusinessInfo(props: IPreviewBusinessInfoProps) {
  const routes = useSelector(selectQuestionnaireRoutes).routes;

  return (
    <>
      <PreviewExpandable title="Business Info">
        {routes.businessInfo.businessType && <PreviewBusinessType />}
        {routes.businessInfo.generalInfo && <PreviewGeneralInfo />}
        {routes.businessInfo.owners && <PreviewOwners />}
        {routes.businessInfo.industryandprimaryactivity && (
          <PreviewIndustryandprimaryactivity />
        )}
      </PreviewExpandable>
    </>
  );
}
